(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-magnetic-talisman-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){var trigger=event.target.closest('[data-mti-shop]');if(!trigger)return;var target=document.querySelector('.product__info-wrapper,product-info,.product__info-container,.ww-product-info');if(target)target.scrollIntoView({behavior:'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-reading-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reading-root]').forEach((root) => {
    const intentions = {
      calm: { intention:'Calm & Balance', crystal:'Amethyst', handle:'amethyst', title:'Amethyst can help restore your inner balance', need:'Your answers show a pattern of mental saturation and emotional tension. Your energy is asking for less noise, steadier rhythms and room to recover.', benefit:'In crystal tradition, Amethyst is associated with calming excess mental activity, intuitive clarity and emotional equilibrium. It is the strongest correspondence for the restorative shift your answers repeatedly selected.', plan:'Explore the Amethyst collection to choose a form that can support a calmer, more balanced environment around you.', affirmation:'I allow calm to return and settle around me.' },
      truth: { intention:'Communication & Flow', crystal:'Aquamarine', handle:'aquamarine', title:'Aquamarine can help your energy move and speak clearly', need:'Your pattern points to unspoken thoughts, emotional holding and communication that gets interrupted before it can become honest connection.', benefit:'Aquamarine is traditionally connected with the throat, emotional flow and calm self-expression. Its correspondence directly supports the clearer, less restricted communication your answers call for.', plan:'Explore the Aquamarine collection to invite clearer communication and easier emotional flow into daily life.', affirmation:'My truth moves through me with calm and clarity.' },
      clarity: { intention:'Clarity & Focus', crystal:'Clear Quartz', handle:'clear-quartz', title:'Clear Quartz can help concentrate your energy', need:'Your answers reveal scattered attention, competing priorities and a need to separate what matters from what merely demands your attention.', benefit:'Clear Quartz is traditionally viewed as an amplifier and clarifier of intention. It matches your need to gather dispersed energy, sharpen focus and direct it toward one meaningful priority.', plan:'Explore the Clear Quartz collection to strengthen focus and bring clearer direction to your goals and surroundings.', affirmation:'My energy gathers around a clear intention.' },
      abundance: { intention:'Wealth & Opportunity', crystal:'Citrine', handle:'citrine', title:'Citrine can help open your field to opportunity', need:'Your reading points to a desire for forward momentum, confidence in your value and a more receptive relationship with work, money or possibility.', benefit:'Citrine is traditionally associated with abundance, optimism, personal will and opportunity. It aligns with the expansion-oriented energy that appears most strongly in your answers.', plan:'Explore the Citrine collection to support an atmosphere of optimism, purposeful action and openness to opportunity.', affirmation:'I recognise opportunity and meet it with action.' },
      love: { intention:'Love & Self-Worth', crystal:'Rose Quartz', handle:'rose-quartz', title:'Rose Quartz can help soften and replenish your heart energy', need:'Your answers suggest that care may be flowing outward more easily than it returns, leaving your own needs, openness or self-worth undernourished.', benefit:'Rose Quartz is traditionally connected with the heart, tenderness, receptivity and self-love. It corresponds with your need for warmer relationships that also protect and replenish you.', plan:'Explore the Rose Quartz collection to invite nurturing, reciprocal love and a gentler emotional atmosphere.', affirmation:'I welcome love that nourishes me in return.' },
      protection: { intention:'Protection & Boundaries', crystal:'Tourmaline', handle:'tourmaline', title:'Tourmaline can help reinforce your energetic boundaries', need:'Your answers repeatedly point to energetic overload from people, environments or obligations. The central issue is not a lack of strength, but too much outside influence entering your field.', benefit:'Black Tourmaline is traditionally associated with grounding, energetic protection and clearing unwanted influence. Its stabilising correspondence makes it the clearest match for strengthening boundaries and returning scattered energy to you.', plan:'Explore the Tourmaline collection to choose a protective piece for your body, personal space or the environment that affects you most.', affirmation:'My energy is my own, protected and grounded.' },
      transformation: { intention:'Transformation & Renewal', crystal:'Malachite', handle:'malachite', title:'Malachite can help move stagnant energy into renewal', need:'Your answers show that part of your life is ready to change, while an old pattern, attachment or identity still holds energy in place.', benefit:'Malachite is traditionally associated with transformation, release and courageous change. It mirrors the transitional energy in your reading and supports movement away from what has become limiting.', plan:'Explore the Malachite collection to support release, renewal and the energy of a more intentional next chapter.', affirmation:'I release what is complete and move toward renewal.' },
      confidence: { intention:'Confidence & Courage', crystal:"Tiger's Eye", handle:'tigers-eye', title:"Tiger's Eye can help turn inner power into decisive action", need:'Your answers reveal ability and ambition that are being slowed by hesitation, second-guessing or fear of choosing the wrong direction.', benefit:"Tiger's Eye is traditionally connected with courage, grounded confidence and discernment. It fits your need to stabilise personal power and convert intention into visible action.", plan:"Explore the Tiger's Eye collection to strengthen courage, decision-making and grounded forward movement.", affirmation:'I trust my power and act with steady courage.' }
    };

    const questions = [
      { kicker:'The energy you are calling in', legend:'If the next chapter of your life could carry one stronger current, what would it be?', guidance:'Choose the shift you want to experience, not the answer you think you should choose.', weight:3, answers:[['calm','A quieter inner world','Less mental noise, more emotional steadiness.'],['abundance','Expansion and opportunity','More movement around work, money and possibility.'],['love','Love that also replenishes me','Warmer connection without losing myself.'],['confidence','The courage to move first','Trusting my decisions and acting visibly.']] },
      { kicker:'Where your field feels open', legend:'Where does your energy seem to leave you most easily?', guidance:'Notice the situation that changes how you feel even after it has ended.', weight:2, answers:[['protection','Around demanding people or heavy spaces','Other moods and expectations stay with me.'],['truth','In conversations where I edit myself','What I really mean remains unspoken.'],['clarity','When too many things compete at once','My attention scatters before anything feels complete.'],['love','When I care for everyone except myself','My own needs become the easiest to postpone.']] },
      { kicker:'The pattern beneath the surface', legend:'Which cycle has been repeating despite your efforts to change it?', guidance:'Your first instinct is usually more revealing than a carefully reasoned answer.', weight:2, answers:[['transformation','Returning to what I have already outgrown','The familiar keeps pulling me away from change.'],['confidence','Waiting for certainty before I act','I know enough, but still hesitate.'],['calm','Pushing through until I feel depleted','Rest arrives only after the pressure becomes too much.'],['abundance','Working hard without feeling momentum','Effort is present, but expansion feels blocked.']] },
      { kicker:'Your elemental response', legend:'When pressure rises, which reaction feels closest to your own?', guidance:'This helps us read how your energy moves when it is under strain.', weight:1, answers:[['calm','My thoughts accelerate','I replay possibilities and struggle to settle.'],['protection','I absorb the atmosphere around me','The room changes my energy quickly.'],['truth','I become quieter than I really am','I hold back to keep things smooth.'],['confidence','I question choices I had already made','My certainty becomes difficult to hold.']] },
      { kicker:'The area asking for attention', legend:'Which part of your life feels most charged at this moment?', guidance:'Choose the area that occupies the most emotional or mental space.', weight:2, answers:[['abundance','Career, money or a new opportunity','I want growth I can actually feel.'],['love','Love, belonging or self-worth','I want connection to feel nourishing.'],['clarity','Direction, decisions or concentration','I need to know where my energy belongs.'],['transformation','An ending, transition or reinvention','Something needs to move into a new form.']] },
      { kicker:'The message you are ready to receive', legend:'Without analysing it, which sentence feels like it was meant to find you?', guidance:'Let resonance make the final choice.', weight:1, answers:[['protection','Not everything deserves access to you','Protection can be an act of self-respect.'],['clarity','One clear intention can reorganise everything','Direction begins when distraction loses authority.'],['truth','Your voice does not need permission','Honesty can move with calm rather than conflict.'],['transformation','The old chapter does not need one more explanation','Release creates the space renewal requires.']] }
    ];

    const birthStep = root.querySelector('[data-reading-birth]');
    const questionStep = root.querySelector('[data-reading-question]');
    const calculationStep = root.querySelector('[data-reading-calculation]');
    const resultStep = root.querySelector('[data-reading-result]');
    const yearInput = root.querySelector('[data-birth-year]');
    const monthInput = root.querySelector('[data-birth-month]');
    const dayInput = root.querySelector('[data-birth-day]');
    const asideImage = root.querySelector('[data-reading-aside-image]');
    const asideLabel = root.querySelector('[data-reading-aside-label]');
    const asideMessage = root.querySelector('[data-reading-aside-message]');
    const defaultAside = { src:asideImage.src, alt:asideImage.alt, label:asideLabel.textContent, message:asideMessage.textContent };
    const collectionVisuals = [...root.querySelectorAll('[data-crystal-visual]')].reduce((map,item) => {
      map[item.dataset.handle] = { src:item.dataset.src, alt:item.dataset.alt };
      return map;
    },{});
    const barsWrap = root.querySelector('[data-reading-bars]');
    const bars = [...barsWrap.children];
    const selections = [];
    let index = 0;
    let birthData = null;

    const digitsOnly = (input) => { input.value = input.value.replace(/\D/g,'').slice(0, Number(input.maxLength)); };
    [[yearInput,4,monthInput],[monthInput,2,dayInput],[dayInput,2,null]].forEach(([input,length,next]) => {
      input.addEventListener('input', () => { digitsOnly(input); if (input.value.length === length && next) next.focus(); });
      input.addEventListener('keydown', (event) => { if (event.key === 'Backspace' && input.value === '' && input !== yearInput) (input === dayInput ? monthInput : yearInput).focus(); });
    });

    const getZodiac = (month,day) => {
      const cutoffs = [20,19,20,20,21,21,22,22,22,23,22,21];
      const signs = ['Capricorn','Aquarius','Pisces','Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn'];
      return day <= cutoffs[month - 1] ? signs[month - 1] : signs[month];
    };

    const getElement = (sign) => {
      if (['Aries','Leo','Sagittarius'].includes(sign)) return 'Fire';
      if (['Taurus','Virgo','Capricorn'].includes(sign)) return 'Earth';
      if (['Gemini','Libra','Aquarius'].includes(sign)) return 'Air';
      return 'Water';
    };

    const getLifePath = (year,month,day) => {
      let value = `${year}${month}${day}`.split('').reduce((sum,n) => sum + Number(n),0);
      while (value > 9 && ![11,22,33].includes(value)) value = String(value).split('').reduce((sum,n) => sum + Number(n),0);
      return value;
    };

    const validateBirth = () => {
      const year = Number(yearInput.value), month = Number(monthInput.value), day = Number(dayInput.value);
      const currentYear = new Date().getFullYear();
      if (yearInput.value.length !== 4) return 'Enter the year using 4 digits.';
      if (monthInput.value.length !== 2 || month < 1 || month > 12) return 'Enter a valid 2-digit month from 01 to 12.';
      if (dayInput.value.length !== 2) return 'Enter the day using 2 digits.';
      const date = new Date(year,month - 1,day,12,0,0);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return 'Enter a valid calendar date.';
      if (year < 1900 || year > currentYear || date > new Date()) return `Enter a year between 1900 and ${currentYear}.`;
      const sign = getZodiac(month,day);
      birthData = { year, month, day, sign, element:getElement(sign), lifePath:getLifePath(year,month,day) };
      return '';
    };

    const renderQuestion = () => {
      const q = questions[index];
      root.querySelector('[data-reading-phase]').textContent = q.kicker;
      root.querySelector('[data-reading-count]').textContent = `${index + 1} of ${questions.length}`;
      root.querySelector('[data-reading-kicker]').textContent = q.kicker;
      root.querySelector('[data-reading-legend]').textContent = q.legend;
      root.querySelector('[data-reading-guidance]').textContent = q.guidance;
      root.querySelector('[data-reading-answers]').innerHTML = q.answers.map((answer,answerIndex) => `<label class="ww-reading-answer"><input type="radio" name="reading-answer" value="${answer[0]}" ${selections[index] === answer[0] ? 'checked' : ''}><span><em>0${answerIndex + 1}</em><strong>${answer[1]}</strong><small>${answer[2]}</small></span></label>`).join('');
      bars.forEach((bar,barIndex) => bar.classList.toggle('is-active',barIndex <= index));
      root.querySelector('[data-answer-error]').textContent = '';
      root.querySelector('[data-reading-next]').textContent = index === questions.length - 1 ? 'Complete my reading' : 'Continue the reading';
    };

    const startReading = () => {
      const error = validateBirth();
      root.querySelector('[data-reading-error]').textContent = error;
      if (error) return;
      birthStep.hidden = true;
      questionStep.hidden = false;
      barsWrap.hidden = false;
      renderQuestion();
    };

    const calculateMatch = () => {
      const score = Object.keys(intentions).reduce((map,key) => ({...map,[key]:0}),{});
      selections.forEach((key,answerIndex) => { score[key] += questions[answerIndex].weight; });
      const elementBonus = { Fire:['confidence','abundance'], Earth:['clarity','abundance'], Air:['truth','clarity'], Water:['calm','love'] };
      elementBonus[birthData.element].forEach((key) => { score[key] += .45; });
      const lifePathKeys = ['confidence','truth','love','clarity','transformation','calm','protection','abundance','transformation'];
      const reducedPath = birthData.lifePath > 9 ? String(birthData.lifePath).split('').reduce((sum,n) => sum + Number(n),0) : birthData.lifePath;
      score[lifePathKeys[reducedPath - 1]] += .35;
      const primaryChoice = selections[0];
      return Object.keys(score).sort((a,b) => score[b] - score[a] || Number(b === primaryChoice) - Number(a === primaryChoice))[0];
    };

    const showResult = (key) => {
      const data = intentions[key];
      root.classList.add('has-reading-result');
      const destination = `/collections/${data.handle}`;
      const matchedVisual = collectionVisuals[data.handle];
      if (matchedVisual && matchedVisual.src) {
        asideImage.classList.add('is-changing');
        window.setTimeout(() => {
          asideImage.src = matchedVisual.src;
          asideImage.alt = matchedVisual.alt || `${data.crystal} collection`;
          asideImage.addEventListener('load',() => asideImage.classList.remove('is-changing'),{once:true});
        },180);
      }
      asideLabel.textContent = `${data.crystal} collection`;
      asideMessage.textContent = `${data.crystal} is your strongest match for ${data.intention.toLowerCase()}.`;
      calculationStep.hidden = true;
      resultStep.hidden = false;
      root.querySelector('[data-reading-phase]').textContent = 'Your crystal alignment';
      root.querySelector('[data-reading-count]').textContent = 'Complete';
      root.querySelector('[data-result-meta]').textContent = `${birthData.sign} 路 ${birthData.element} element 路 Life Path ${birthData.lifePath}`;
      root.querySelector('[data-result-theme]').textContent = data.title;
      root.querySelector('[data-result-summary]').textContent = `Across your six answers, ${data.intention.toLowerCase()} emerged as the energy area asking for the most support. Your birth pattern adds a ${birthData.element.toLowerCase()} influence, while your Life Path ${birthData.lifePath} provides a secondary layer to the match.`;
      root.querySelector('[data-result-reflection]').textContent = data.need;
      root.querySelector('[data-result-birth]').textContent = `Born under ${birthData.sign}, your ${birthData.element.toLowerCase()} element shapes how energy tends to move under pressure. Life Path ${birthData.lifePath} adds a supporting numerology influence; it informs the match but does not override your present answers.`;
      root.querySelector('[data-result-reason]').textContent = data.benefit;
      root.querySelector('[data-result-stone]').textContent = data.crystal;
      root.querySelector('[data-result-intention]').textContent = data.intention;
      root.querySelector('[data-result-plan]').textContent = data.plan;
      root.querySelector('[data-result-affirmation]').textContent = `"${data.affirmation}"`;
      root.querySelector('[data-result-link]').href = destination;
      localStorage.setItem('wwCrystalResult',JSON.stringify({ intention:data.intention, crystal:data.crystal, handle:data.handle, sign:birthData.sign, lifePath:birthData.lifePath, createdAt:new Date().toISOString() }));
      resultStep.scrollIntoView({behavior:'smooth',block:'start'});
    };

    const runCalculation = () => {
      questionStep.hidden = true;
      barsWrap.hidden = true;
      calculationStep.hidden = false;
      root.querySelector('[data-reading-phase]').textContent = 'Calculating your alignment';
      root.querySelector('[data-reading-count]').textContent = 'Please wait';
      const progress = root.querySelector('[data-calculation-progress]');
      const titles = ['Reading your birth signature','Weighing your present energy pattern','Matching traditional crystal correspondences'];
      const copies = ['Locating your zodiac element and numerology pattern.','Finding the needs and obstacles that repeated across your answers.','Comparing your strongest pattern with eight crystal energy traditions.'];
      const match = calculateMatch();
      const matchedVisual = collectionVisuals[intentions[match].handle];
      if (matchedVisual && matchedVisual.src) {
        const preload = new Image();
        preload.src = matchedVisual.src;
      }
      [0,1,2].forEach((step) => {
        window.setTimeout(() => {
          root.querySelector('[data-calculation-title]').textContent = titles[step];
          root.querySelector('[data-calculation-copy]').textContent = copies[step];
          root.querySelectorAll('[data-calc-step]').forEach((item,itemIndex) => item.classList.toggle('is-active',itemIndex <= step));
          progress.style.transform = `scaleX(${(step + 1) / 3})`;
        },step * 760);
      });
      window.setTimeout(() => showResult(match),2450);
    };

    root.querySelector('[data-reading-start]').addEventListener('click',startReading);
    root.querySelector('[data-reading-next]').addEventListener('click',() => {
      const selected = root.querySelector('[data-reading-answers] input:checked');
      if (!selected) { root.querySelector('[data-answer-error]').textContent = 'Choose the response that feels closest before continuing.'; return; }
      selections[index] = selected.value;
      if (index < questions.length - 1) { index += 1; renderQuestion(); questionStep.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      runCalculation();
    });
    root.querySelector('[data-reading-back]').addEventListener('click',() => {
      if (index === 0) { questionStep.hidden = true; birthStep.hidden = false; barsWrap.hidden = true; root.querySelector('[data-reading-phase]').textContent = 'Your birth pattern'; root.querySelector('[data-reading-count]').textContent = 'Start'; }
      else { index -= 1; renderQuestion(); }
    });
    root.querySelector('[data-reading-restart]').addEventListener('click',() => {
      selections.length = 0; index = 0; root.classList.remove('has-reading-result'); resultStep.hidden = true; birthStep.hidden = false; root.querySelector('[data-reading-phase]').textContent = 'Your birth pattern'; root.querySelector('[data-reading-count]').textContent = 'Start';
      asideImage.classList.add('is-changing');
      window.setTimeout(() => {
        asideImage.src = defaultAside.src;
        asideImage.alt = defaultAside.alt;
        asideImage.addEventListener('load',() => asideImage.classList.remove('is-changing'),{once:true});
      },180);
      asideLabel.textContent = defaultAside.label;
      asideMessage.textContent = defaultAside.message;
      root.scrollIntoView({behavior:'smooth',block:'start'});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-silver-larimar-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slp-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-slp-slide]')];
    const dots = [...slider.querySelectorAll('[data-slp-dot]')];
    if (slides.length < 2) return;
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const selected = position === active;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
      });
      dots.forEach((dot, position) => {
        const selected = position === active;
        dot.classList.toggle('is-active', selected);
        if (selected) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    };
    slider.querySelector('[data-slp-prev]')?.addEventListener('click', () => show(active - 1));
    slider.querySelector('[data-slp-next]')?.addEventListener('click', () => show(active + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slpDot))));
    let touchStartX = 0;
    slider.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      show(distance < 0 ? active + 1 : active - 1);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
